import { useTranslation } from "react-i18next";
import Logo from "../../docs/logo/light.png";
import '../../style/components/loading.css';

export default function Loading() {
    const { t } = useTranslation();
    return (
        <div className="loading flex flex-center-center">
            <div className="loading-logo">
                <img src={Logo} alt="loading" />
            </div>
            <div className="loading-text">
                {t("common:searching")}...
            </div>
        </div>
    )
}